import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const useDeleteCustomTheme = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete(`/api/custom_themes/${id}`);
            return response.data;
        },
        onSuccess: () => {
            // Invalidate custom theme cache to refetch the themes
            queryClient.invalidateQueries(["customTheme"]);
            queryClient.invalidateQueries(["getAllCustomTheme"]);
        },
    });

    return query;
};
